import { render, staticRenderFns } from "./SingleTest.vue?vue&type=template&id=3f0206d8"
import script from "./SingleTest.vue?vue&type=script&lang=js"
export * from "./SingleTest.vue?vue&type=script&lang=js"
import style0 from "./SingleTest.vue?vue&type=style&index=0&id=3f0206d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports